import React from "react";
import { getIconName } from "../../util/contentModelToData";
import Icon from "../atoms/Icon";

export default ({ title, url, className, isRound }) =>
    <a
        className={ `m-social-media${isRound ? " m-social-media--round" : ""}${ className ? ` ${className}` : ""}` }
        href={ url }
        target="_blank"
        rel="noopener noreferrer nofollow"
    >
        <Icon className={ "m-social-media__icon a-icon a-icon--s" } iconName={ (getIconName(title)) }/>
        <span className={ (isRound ? "u-visually-hidden" : "m-social-media__title") }>
            { title }
        </span>
    </a>;